import React from "react";
import UserLogin from "@v2/components/logIn";

const LoginPage = () => {
    return (
        <div className="user_login">
            <UserLogin />
        </div>
    );
};

export default LoginPage;
